import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { useAppContext } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import Tabs from "@/components/blocks/theme/tabbed-content/tabs/tabs"

export default function Wrapper({ block }) {
  const { attrs, innerBlocks } = block
  const router = useRouter()
  const [selectedTab, setSelect] = useState(
    attrs.tabs.length === 0 ? "" : attrs.tabs[0]["slug"]
  )

  const { setTabMounted, tabContent } = useAppContext()
  const tabs = attrs.tabs

  const handleSelect = (tab) => {
    const url = router.query.slug.join("/") + "/?tab=" + tab
    router.push(url, "", {
      shallow: true
    })
    setSelect(tab)
  }

  useEffect(() => {
    setTabMounted(true)
  }, [])

  useEffect(() => {
    router.query.tab ? setSelect(router.query.tab) : ""
  }, [router.query.tab])

  if (attrs.tabs.length === 0) {
    return null
  }

  const currentTab = innerBlocks.filter(
    (block) => block.attrs.slug === selectedTab
  )

  return (
    <Block block={block} ref={tabContent}>
      <Tabs tabs={tabs} onSelect={handleSelect} activeTab={selectedTab} />
      <Blocks blocks={currentTab} />
    </Block>
  )
}
